import { render, staticRenderFns } from "./ReviewPay.vue?vue&type=template&id=57f424f0"
import script from "./ReviewPay.vue?vue&type=script&lang=js"
export * from "./ReviewPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports